// extracted by mini-css-extract-plugin
module.exports = {"container":"Bank_container__Aeph2"};